import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import Img1 from "./about1.png";
import Img2 from "./about2.png";
import Img3 from "./culture.png";
import Person1 from "./person1.png";
import Person2 from "./person2.png";
import Person3 from "./person3.png";
import Img4 from "./iconimg1.png";
import Img5 from "./iconimg2.png";
import Img6 from "./iconimg3.png";
import Container from "react-bootstrap/Container";
import "./aboutus.css";
const Aboutus = () => {
  return (
    <>
      <Navb />
      <img src={Img1} alt="img1" style={{ width: "-webkit-fill-available" }} />
      <div className="aboutus">
        <Container>
          <div className="whiteHeading">What we do</div>
          <div style={{ padding: "3px 0px" }} className="whiteP">
            Nandi Agro is a decade old renowned Agro Product Manufacturer. Nandi
            Agro is a leader in food grain business owing its emphasis on
            maintaining quality. We host the latest milling and grinding
            technology to provide top quality products. We are one of the top
            flour manufacturers with huge network in Uttar Pradesh. We have wide
            range of products like Atta, Maida, Sooji, Dalia, Himalayan Salt,
            etc. Ingredients are carefully hand-picked and processed with the
            same love and care with which you prepare your food.
          </div>
          <div style={{ padding: "3px 0px" }} className="whiteP">
            Nandi goes straight to the source for the finest grains to produce
            the best ingredients that you can use in your kitchen. The grains
            are UNTOUCHED to maintain proper level of hygiene and mental
            wellbeing. NO PRESERVATIVES ensure you get authentic organic food
            product. To lock-in the freshness of products, Nandi uses world
            class technology in packaging across all categories - whether it is
            the PET Poly Packaging used to give you fresh Chakki Atta or the
            four layer international pouch to retain the flavour of Salt.
          </div>
          <div style={{ padding: "3px 0px" }} className="whiteP">
            Our products are free from all artificial preservatives which help
            in mental as well as physical growth of the family members.
          </div>
        </Container>
      </div>
      <div className="aboutusBot">
        <Container className="aboutusBotContent">
          <img src={Img2} alt="Img2" />
          <div>
            <div className="blackHeading">Our Story</div>
            <div className="blackP">
              Discover Nandi's extraordinary culinary tale – fuelled by passion
              and vision from the ground up. Immerse yourself in the essence of
              our journey, savouring unique flavours that define our story. Join
              us, and let the Nandi experience unfold.
            </div>
          </div>
        </Container>
        <Container
          className="blackP"
          style={{ width: "90%", margin: "0px auto" }}
        >
          A culinary odyssey that began from the bottom ground with high
          motivation and an unmistakable resemblance to the dreams we aspired to
          bring to life. Our dedication unfolded in every step of our process.
          We weren't just makers; we were artisans shaping culinary experiences.
          From giving atta with a choker, symbolizing our pledge to offer the
          best, to the intricate dance of washing grains, drying, storing,
          filtering, and grinding. Each phase was a symphony of care, attention,
          and a relentless pursuit of perfection. But Nandi's story transcends
          the boundaries of our kitchen. Our aspirations reached beyond four
          walls; we aimed to grow our products from house to house, transcending
          borders and touching hearts across the entire country and the world.
          Atta, Maida, and Sooji weren't just ingredients; they were ambassadors
          of Indian taste, sharing the rich tapestry of our culinary heritage.
        </Container>
      </div>
      <div className="leaders">
        <Container>
          <div className="oneLeader">
            <img src={Person1} alt="Person1" />
            <div className="leaderbox">
              <div className="leaderPosition">CEO</div>
              <div className="leaderName">Mr. Abhishek Gupta</div>
              <div className="leadersText">
                Meet the dynamic MD of Nandi Group and Ecavo Agro, a visionary
                leader driving global excellence. Armed with a Business
                Executive Programme certification from SP Jain Institute of
                Management and Research (Mumbai) & London School of Economics,
                he wields strategic acumen that propels Nandi to new heights.
                With over 10 years of entrepreneurship experience, he's honored
                as UP's AnmolRatan and recognized by the MSME minister for
                leading one of UP's fastest-growing companies. Passionate about
                meaningful brands and strong leadership, he's a driving force in
                business growth and negotiation mastery.
              </div>
            </div>
          </div>
        </Container>
        <Container>
          <div
            className="oneLeader"
            style={{ display: "flex", "justify-content": "flex-end" }}
          >
            <img src={Person2} alt="Person2" />
            <div className="leaderbox">
              <div className="leaderPosition1">GM Sales</div>
              <div className="leaderName1">Mr. Rajiv Kumar Tripathi</div>
              <div className="leadersText1">
                Leading sales and marketing at Nandi Agro with 22 years of FMCG
                expertise, excels in business development, strategic planning,
                and channel distribution. <br /> A positive and people-oriented
                leader, Rajiv guides the team toward achieving shared goals.
              </div>
            </div>
          </div>
        </Container>
        <Container>
          <div className="oneLeader">
            <img src={Person3} alt="Person3" />
            <div className="leaderbox">
              <div className="leaderPosition2">Legal Executive</div>
              <div className="leaderName2">Mr. Ritesh Srivastava</div>
              <div className="leadersText2">
                Management Representative at Ecavo, spearheads corporate
                administration affairs. With a Law degree and a Master's in
                Commerce, he brings over 15 years of rich experience, including
                leadership roles at HPCL and in the Hospitality Industry.
              </div>
            </div>
          </div>
        </Container>
      </div>
      <div className="mottoBox">
        <div className="mottoTitle">Our Motto</div>
        <div className="motto">
          <div className="productCard1">
            <div className="productCardheading1 ">VISION</div>
            <div
              style={{
                position: "relative",
                "background-color": "#F2F2F2",
                height: "19rem",
              }}
            >
              <img className="productCardImg1 " src={Img4} alt="Img" />
              <p
                style={{
                  padding: "6rem 1rem 0rem 1rem",
                  "text-align": "center",
                }}
              >
                TexEmpowering communities with good, healthy food. Our vision is
                to cultivate a future where nourishment is accessible,
                sustaining well-being for every individual.
              </p>
            </div>
          </div>
          <div className="productCard2">
            <div className="productCardheading1 ">MISSION</div>
            <div
              style={{
                position: "relative",
                "background-color": "#F2F2F2",
                height: "19rem",
              }}
            >
              <img className="productCardImg1 " src={Img5} alt="Img" />
              <p
                style={{
                  padding: "6rem 1rem 0rem 1rem",
                  "text-align": "center",
                }}
              >
                We're devoted to safeguarding your family's well-being with a
                steadfast mission and a holistic perspective.
              </p>
            </div>
          </div>
          <div className="productCard3">
            <div className="productCardheading1 ">BELIEFS</div>
            <div
              style={{
                position: "relative",
                "background-color": "#F2F2F2",
                height: "19rem",
              }}
            >
              <img className="productCardImg1 " src={Img6} alt="Img" />
              <p
                style={{
                  padding: "6rem 1rem 0rem 1rem",
                  "text-align": "center",
                }}
              >
                Believe in the right to affordable, good and healthy food for
                all. We ensure strict quality checks and adopt a holistic
                approach, ceaselessly pursuing excellence.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="culture">
        <div className="blackHeading">Culture</div>
        <Container>
          <img
            src={Img3}
            alt="Img3"
            style={{ width: "-webkit-fill-available" }}
          />
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Aboutus;
